__turbopack_context__.v({
  "calculate": "PropositionCardSkeleton-module-scss-module__TjuNCq__calculate",
  "content": "PropositionCardSkeleton-module-scss-module__TjuNCq__content",
  "line": "PropositionCardSkeleton-module-scss-module__TjuNCq__line",
  "perks": "PropositionCardSkeleton-module-scss-module__TjuNCq__perks",
  "price": "PropositionCardSkeleton-module-scss-module__TjuNCq__price",
  "proposition-skeleton": "PropositionCardSkeleton-module-scss-module__TjuNCq__proposition-skeleton",
  "skeleton-loading": "PropositionCardSkeleton-module-scss-module__TjuNCq__skeleton-loading",
  "title": "PropositionCardSkeleton-module-scss-module__TjuNCq__title",
  "transfer-now": "PropositionCardSkeleton-module-scss-module__TjuNCq__transfer-now",
});
